import { LinkedContact } from "@/Common/Api/Patient/Dto/LinkedContact";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { PatientIdentifier } from "@/Common/Models/Patient/PatientIdentifier";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { HealthCardsView } from "@/Patient/Components/Profile/Identifiers/HealthCardsView";
import { OtherIdentifiersView } from "@/Patient/Components/Profile/Identifiers/OtherIdentifiersView";
import { Relative } from "../Models/Relative";
import { relativeStore } from "../Stores/RelativeStore";

function IdentifiersView(): JSX.Element {
    const { getText } = useTranslation();

    const relative: Relative = relativeStore.GetCurrent();
    const healthCards: PatientIdentifier[] = relative.HealthCards;
    const representant: LinkedContact = relative.Relationships.firstOrDefault(p => p.IsRepresentative);
    const otherIds: PatientIdentifier[] = relative.OtherPatientIdentifiers;

    return (
        <div className="tabComponent">
            <div className="tabComponent-main patient-prof patient-identifiers">
                <div className="block separated">
                    <div className="flex-container heading">
                        <h3 className="thin-font">{getText("HealthCard")}</h3>
                    </div>
                    <div className="psingle-column centered">
                        <HealthCardsView healthCards={healthCards} representant={representant} />
                    </div>
                </div>
                <div className="block separated">
                    <div className="flex-container heading">
                        <h3 className="thin-font">{getText("OtherIdentifierslabel")}</h3>
                    </div>
                    <div className="psingle-column centered">
                        <OtherIdentifiersView identifiers={otherIds} />
                    </div>
                </div>
            </div>
            <div className="tabComponent-footer ws-subfooter patient-profile">
                <div className="tb patient-profile-footer">
                    <div className="tbc pull-right">
                        <ButtonControl
                            className="btn btn-primary pull-right"
                            onClick={() => sessionStore.dispatch(LocalOperations.Relative.EditProfile)}
                            label={getText("EDITLabel")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export { IdentifiersView };
